import { SimulationBO } from "./SimulationBO";
import _ = require("lodash");
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";

export class SimulationBOValidation {
    static Validation(aBO: SimulationBO): Promise<void> {
        return new Promise<void>((resolve, error) => {
            if (aBO.WB_Simulation.cif.DELETED_IND == "1") {
                resolve();
                return;
            }
            SimulationBOValidation.ValidateDate(aBO)
                .then((ignore) => {
                    // if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                    // }

                    return SimulationBOValidation.ValidateFields(aBO);
                })
                .then((ignore) => {
                    resolve();
                    return;
                });
        });
    }

    static getFormattedDate(date: Date) {
        let year = date.getFullYear();

        let month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : "0" + month;

        let day = date.getDate().toString();
        day = day.length > 1 ? day : "0" + day;

        return month + "/" + day + "/" + year;
    }

    static ValidateDate(aBO: SimulationBO): Promise<void> {
        const self = this;
        return new Promise((resolve, reject) => {
            let message = "";

            let simulationDate = aBO.WB_Simulation.StartDate;
            let publishedModelValidityStartDate = aBO.WB_Simulation.WB_PublishedModelRow.EffectiveStartDt;
            let publishedModelValidityEndDate = aBO.WB_Simulation.WB_PublishedModelRow.EffectiveEndDt;

            if (!(simulationDate >= publishedModelValidityStartDate && simulationDate <= publishedModelValidityEndDate))
                message =
                    "Simulation Start Date " +
                    SimulationBOValidation.getFormattedDate(simulationDate) +
                    " has to be within Published Model Validity (" +
                    SimulationBOValidation.getFormattedDate(publishedModelValidityStartDate) +
                    "-" +
                    SimulationBOValidation.getFormattedDate(publishedModelValidityEndDate) +
                    ")";

            simulationDate = aBO.WB_Simulation.EndDate;
            if (
                simulationDate &&
                !(simulationDate >= publishedModelValidityStartDate && simulationDate <= publishedModelValidityEndDate)
            ) {
                if (!_.isEmpty(message)) message += "\r";
                message +=
                    "Simulation End Date " +
                    SimulationBOValidation.getFormattedDate(simulationDate) +
                    " has to be within Published Model Validity (" +
                    SimulationBOValidation.getFormattedDate(publishedModelValidityStartDate) +
                    "-" +
                    SimulationBOValidation.getFormattedDate(publishedModelValidityEndDate) +
                    ")";
            }

            if (!_.isEmpty(message)) {
                self.addMessage(aBO, MessageType.Error, "InvalidEndDate", message);
            } else {
                aBO.ValidateMessageProvider.removeMessage("InvalidEndDate");
            }
            resolve();
        });
    }

    static ValidateFields(aBO: SimulationBO): Promise<void> {
        const self = this;

        return new Promise((resolve, reject) => {
            let prefix = "/AZR/SA_";

            //Validate Customer field
            // if (aBO.WB_Simulation.cif.DELETED_IND=='1'){
            //     resolve()
            //     return
            // }

            console.log(aBO.WB_Simulation.cif.END_DT, aBO.WB_Simulation.WB_PublishedModelRow.cif.EFFECTIVE_END_DT);

            if (aBO.WB_Simulation.cif.WB_CUST_ID == 0) {
                self.addMessage(aBO, MessageType.Error, "EmptyCustomer", "Customer cannot be empty");
            } else {
                aBO.ValidateMessageProvider.removeMessage("EmptyCustomer");
            }

            if (aBO.WB_Simulation.cif.SIMULATION_NAME.includes("/")) {
                self.addMessage(
                    aBO,
                    MessageType.Error,
                    "IllegalCharacter",
                    "Unable to save. Please remove any special characters from the name and try saving again"
                );
            } else {
                aBO.ValidateMessageProvider.removeMessage("IllegalCharacter");
            }

            let warningMessage = "Save Successful.";
            if (aBO.ValidateMessageProvider.countMessages(MessageType.Error) > 0) warningMessage = "";

            if (_.isEmpty(aBO.WB_Simulation.cif.TREE_PATH)) {
                self.addMessage(
                    aBO,
                    MessageType.Information,
                    "EmptyTreePath",
                    warningMessage +
                        (!aBO.WB_Simulation.cif.SIMULATION_NAME.includes("Copy")
                            ? " If you wish to save to a folder please enter a folder structure into the Tree Path on the Main tab of the Simulation"
                            : "")
                );
            } else {
                aBO.ValidateMessageProvider.removeMessage("EmptyTreePath");
            }

            resolve();
        });
    }

    private static addMessage(aBO: SimulationBO, type: number, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage({
            code: code,
            type: type,
            title: message,
            description: "",
            subtitle: "",
            count: 0,
        });
    }
}
